import React from 'react';
import Navbar from './global-components/navbar';
import PageHeader from './global-components/page-header';
import NETCourses from './section-components/NET-details';
import Footer from './global-components/footer-v2';
import {Helmet} from "react-helmet";

const NET = () => {
    return <div>
        <Navbar />
        <Helmet>
            <title>NET Coaching Chennai | Test For Teaching Profession and Research</title>
            <meta name="description" content="MIET Education Chennai provides coaching classes for NET aspirants preparing for the National Eligibility Test conducted by University Grants Commission." />
        </Helmet>
        <PageHeader headertitle="NET"  />
        <NETCourses />
        <Footer />
    </div>
}

export default NET